import { LinearProgress, Typography } from '@material-ui/core';
import React, { ReactElement, useEffect } from 'react';
import Helmet from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { compose } from 'redux';
import { reduxForm } from 'redux-form/immutable';

import { selectUser } from 'entities/user/selectors';
import PageHeaderRedesign from 'retired/PageHeaderRedesign';
import { useInjectEpics } from 'utils/injectEpics';
import { useInjectReducer } from 'utils/injectReducer';
import { Privileges } from 'utils/privileges';
import { Features } from 'utils/features';

import { CorporateDonationDonateForm } from './CorporateDonationDonateForm';
import epics, { CorporateDonationInitialState } from './epics';
import reducer from './reducer';
import { selectError, selectLoading } from './selectors';
import { FORM_IDENTIFIER, initAction, submitAction } from './types';

const withForm = reduxForm({
  initialValues: { ...CorporateDonationInitialState },
  form: FORM_IDENTIFIER,
});

const CorporateDonationDonateFormPage = ({
  pristine,
  invalid,
  submitting,
  handleSubmit,
  form,
  change,
}): ReactElement => {
  const dispatch = useDispatch();
  useInjectEpics({ key: 'corporateDonationDonateFormPage', epics });
  useInjectReducer({ key: 'corporateDonationDonateFormPage', reducer });

  const error = useSelector(selectError);
  const loading = useSelector(selectLoading);
  const user = useSelector(selectUser);
  const history = useHistory();

  useEffect(() => {
    if (
      user &&
      !(
        (user.hasPrivilege(Privileges.DONATION_CORPORATE_DONATE) &&
          user.hasFeature(Features.CORPORATE_DONATIONS)) ||
        (user.hasPrivilege(Privileges.DONATION_CORPORATE_LOG) &&
          user.hasFeature(Features.EXTERNAL_CORPORATE_DONATIONS))
      )
    ) {
      history.replace('/');
    }
  });

  useEffect(() => {
    dispatch(initAction());
  }, []);

  const submit = (formData) => {
    dispatch(submitAction(formData));
  };

  return (
    <div>
      <Helmet title="Make a corporate donation" />
      <PageHeaderRedesign
        title="Make a corporate donation"
        onArrowClick={() =>
          history.length > 0 ? history.goBack() : history.push('/donations/corporate')
        }
      />

      {(loading || submitting) && <LinearProgress />}
      {!loading ? (
        <form onSubmit={handleSubmit(submit)}>
          <fieldset>
            <CorporateDonationDonateForm
              pristine={pristine}
              invalid={invalid}
              submitting={submitting}
              form={form}
              change={change}
            />
          </fieldset>
        </form>
      ) : (
        <></>
      )}
      {error && (
        <Typography>Failed to make your Corporate Donation. Please try again later</Typography>
      )}
    </div>
  );
};

export default compose(withForm)(CorporateDonationDonateFormPage);
